import React, { useContext } from "react";
import { ContentSection } from "sprint-common-web";

import { SystemPlatformListingContext } from "./context/SystemPlatformListingContext";

export const ShreqIdSection = (): JSX.Element => {
    const { shreqId, isLoading } = useContext(SystemPlatformListingContext);

    return (
        <ContentSection testId="shreq-id-section" header="Shreq Id" isLoading={isLoading}>
            {shreqId}
        </ContentSection>
    );
};
